import React, { useEffect } from "react"
import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import LandingPage from "views/landing";
import SignInCentered from "views/auth/signIn";
import SignUpCentered from "views/auth/signUp";
import ForgotPassword from "views/auth/ForgotPassword";
import PricingPage from "views/pricing"   // ✅ 추가
import { Toaster } from "sonner";   // ✅ ADD THIS

import Privacy from "pages/Privacy";
import Terms from "pages/Terms";
import TestSheet from "views/admin/products/components/TestSheet";

function App() {

  useEffect(() => {
    const handleForceSignOut = () => {
      localStorage.removeItem("access_token");
      window.location.href = "/signin"; // 로그인 페이지로 이동
    };

    window.addEventListener("forceSignOut", handleForceSignOut);
    return () => window.removeEventListener("forceSignOut", handleForceSignOut);
  }, []);

  return (
    <>
      {/* ✅ GLOBAL TOAST */}
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            background: "#111",
            color: "#e5e7eb",
            border: "1px solid #262626",
          },
        }}
      />
    <Routes>
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/sign-in" element={<SignInCentered />} />
      <Route path="/sign-up" element={<SignUpCentered />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/" element={<Navigate to="/landing" replace />} />
      <Route path="*" element={<Navigate to="/landing" replace />} />
    </Routes>
    </>
  );
}

export default App;


